import AppConfigProvider, { useAppConfig } from './appConfig';

export { AppConfigProvider, useAppConfig };
